import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from "react-router-dom";

const Footer = () => {

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div>
            <footer className="main">
                <section className="newsletter mb-15 wow animate__animated animate__fadeIn">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="position-relative newsletter-inner">
                                    <div className="newsletter-content">
                                        <h2 className='mb-20 text-white'>
                                            Crafted by Nature, Curated by  Stone Skill <br />
                                            Discover  &amp;  our exclusive stone collection
                                        </h2>
                                        <p className="mb-45 text-white">Start you’re Daily Shopping with
                                            <span className="text-brand"></span>
                                        </p>
                                    </div>
                                    <img src="/assets/imgs/banner/banner-9.png" alt="newsletter" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-padding footer-mid">
                    <div className="container pt-15 pb-20">
                        <div className="row">
                            <div className="col">
                                <div className="widget-about font-md mb-md-3 mb-lg-3 mb-xl-0 wow animate__animated animate__fadeInUp" data-wow-delay={0}>
                                    <div className="logo mb-30">
                                        <Link to="/" className="mb-15 "><img src="/assets/imgs/logo/2.png" alt="logo" style={{ width: "280px" }} /></Link>
                                    </div>
                                    <ul className="contact-infor">
                                        <li><img src="/assets/imgs/theme/icons/icon-location.svg" alt /><strong>Address: </strong> <span>Aurangabad Jalgaon Highway <br /> Behind Hotel Pawan & lodging Ajanta <br /> Pincode:-431117</span></li>
                                        <li><img src="/assets/imgs/theme/icons/icon-contact.svg" alt /><strong>Call Us:</strong><Link to={'tel:+91 9049045886'}>+91 9049045886</Link></li>
                                        {/* <li><img src="/assets/imgs/theme/icons/icon-email-2.svg" alt /><strong>Email:</strong><Link to={'Stones@outlook.com'}> Stones@outlook.com</Link></li> */}
                                        <li><img src="/assets/imgs/theme/icons/icon-email-2.svg" alt /><strong>Email:</strong><Link to={'https://mail.google.com/mail/?view=cm&fs=1&to=Stones@outlook.com'} target="_blank" rel="noopener noreferrer" >Stones@outlook.com</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="footer-link-widget col wow animate__animated animate__fadeInUp" data-wow-delay=".1s">
                                <h4 className=" widget-title">Company</h4>
                                <ul className="footer-list mb-sm-5 mb-md-0">
                                    <li><Link to={'/'}>About Us</Link></li>
                                    <li><Link to={'/'}>Delivery Information</Link></li>
                                    <li><Link to={'/'}>Privacy Policy</Link></li>
                                    <li><Link to={'/'}>Terms &amp; Conditions</Link></li>
                                    <li><Link to={'/Contact'}>Contact Us</Link></li>
                                    <li><Link to={'/'}>Support Center</Link></li>
                                    <li><Link to={'/'}>Careers</Link></li>
                                </ul>
                            </div>
                            <div className="footer-link-widget col wow animate__animated animate__fadeInUp" data-wow-delay=".2s">
                                <h4 className="widget-title">Account</h4>
                                <ul className="footer-list mb-sm-5 mb-md-0">
                                    <li><Link to={'/CreateAccount'}>Sign In</Link></li>
                                    <li><Link to={'/AddToCart'}>View Cart</Link></li>
                                    <li><Link to={'/WishList'}>My Wishlist</Link></li>
                                </ul>
                            </div>
                            <div className="footer-link-widget widget-install-app col wow animate__animated animate__fadeInUp" data-wow-delay=".5s">
                                <h4 className="widget-title">Install App</h4>
                                <p className>From App Store or Google Play Store</p>
                                <div className="download-app">
                                    <a href="#" className="hover-up mb-sm-2 mb-lg-0"><img className="active" src="/assets/imgs/theme/app-store.jpg" /></a>
                                    <a href="#" className="hover-up mb-sm-2"><img src="/assets/imgs/theme/google-play.jpg" /></a>
                                </div>
                                <p className="mb-20">Secured Payment Gateways</p>
                                <img className src="/assets/imgs/theme/payment-method.png" />
                            </div>
                        </div>
                    </div>
                </section>
                <div className="container pb-30 wow animate__animated animate__fadeInUp" data-wow-delay={0}>
                    <div className="row align-items-center">
                        <div className="col-12 mb-30">
                            <div className="footer-bottom" />
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <p className="font-sm mb-0">© 2025, <strong className="text-brand">DualSysco</strong>All rights reserved</p>
                        </div>
                        <div className="col-xl-4 col-lg-6 text-center d-none d-xl-block">
                            <div className="hotline d-lg-inline-flex mr-30">
                                <img src="/assets/imgs/theme/icons/phone-call.svg" alt="hotline" />
                                <p>+919049045886<span>Working 8:00 - 22:00 24/7 Support Center</span></p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 text-end d-none d-md-block">
                            <div className="mobile-social-icon">
                                <h6>Follow Us</h6>
                                <a href="#"><img src="/assets/imgs/theme/icons/icon-facebook-white.svg" /></a>
                                <a href="#"><img src="/assets/imgs/theme/icons/icon-twitter-white.svg" /></a>
                                <Link to={'https://www.instagram.com/stoneskill07?igsh=MXFxcmpmY2c0MnhnMg%3D%3D'}><img src="/assets/imgs/theme/icons/icon-instagram-white.svg" /></Link>
                                <a href="#"><img src="/assets/imgs/theme/icons/icon-pinterest-white.svg" /></a>
                                <a href="#"><img src="/assets/imgs/theme/icons/icon-youtube-white.svg" /></a>
                            </div>
                            <p className="font-sm">Up to 15% discount on your first subscribe</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div >
    )
}

export default Footer;